import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { LanguageCode } from '@/gql/graphql'
import pt from './locales/pt'
import { FALLBACK_LANGUAGE_CODE } from './languages'

i18n.use(initReactI18next).init({
  resources: {
    pt: { translation: pt },
  },
  lng: FALLBACK_LANGUAGE_CODE,
  fallbackLng: FALLBACK_LANGUAGE_CODE,
  interpolation: { escapeValue: false },
})

const loadedLanguages = new Set<LanguageCode>([FALLBACK_LANGUAGE_CODE])

export async function loadLanguage(code: LanguageCode) {
  if (!loadedLanguages.has(code)) {
    const { default: translation } =
      code === LanguageCode.En ? await import('./locales/en') : await import('./locales/pt')
    i18n.addResourceBundle(code, 'translation', translation, true, true)
    loadedLanguages.add(code)
  }
  await i18n.changeLanguage(code)
}

export default i18n
